<template>
  <v-app>
      <router-view v-if="!embedded" name="header" v-model="expandOnHover" />
      <router-view v-if="!embedded" name="sideBar" :expand-on-hover.sync="expandOnHover" />
      <v-main>
      <v-snackbar v-model="versionMismatch" :timeout="-1" top color="transparent" elevation="0" class="version-toast">
        <div class="version-toast__surface">
          <div class="version-toast__eyebrow">Masterboard</div>
          <div class="version-toast__message">{{ $t('version-update-message') }}</div>
          <div class="version-toast__actions">
            <button type="button" class="version-toast__button version-toast__button--later" @click="dismissVersionUpdate">
              {{ $t('version-update-later') }}
            </button>
            <button type="button" class="version-toast__button version-toast__button--reload" @click="reloadApplication">
              {{ $t('version-update-reload') }}
            </button>
          </div>
        </div>
      </v-snackbar>
       <v-overlay style='z-index:99999' :value="$store.state.global_overlay">
        <v-row
          ><v-col
            ><v-alert border="top" colored-border type="info" elevation="2"
              >{{ $store.state.global_overlay_text }}&nbsp;<v-progress-circular
                :indeterminate="true"
                :rotate="0"
                :size="32"
                :width="4"
                color="primary"
              ></v-progress-circular></v-alert></v-col
        ></v-row>
      </v-overlay>
      <v-fade-transition mode="out-in">
      <router-view name="main"/>
      </v-fade-transition>
      </v-main>
      <router-view v-if="!embedded" name="footer"/>
      
    </v-app>
</template>

<script>
import {
  dismissVersionMismatch,
  isEmbedded,
} from "./services/embeddedNavigation";

export default {
  name: 'app',
  data: () => ({
      expandOnHover: true,
      versionMismatch: false,
      mismatchVersion: null,
  }),
  computed: {
    embedded() {
      return isEmbedded();
    }
  },
  mounted() {
    window.addEventListener('app-version-mismatch', this.showVersionMismatch);
  },
  beforeDestroy() {
    window.removeEventListener('app-version-mismatch', this.showVersionMismatch);
  },
  methods: {
    showVersionMismatch(event) {
      this.versionMismatch = true;
      this.mismatchVersion = event.detail && event.detail.version;
    },
    dismissVersionUpdate() {
      dismissVersionMismatch(this.mismatchVersion);
      this.versionMismatch = false;
    },
    reloadApplication() {
      window.location.reload();
    },
  }
}
</script>

<style lang="scss">
@import 'sass/variables.scss';
@import 'assets/app.scss';
@import 'assets/app.css';
</style>

<style>
.version-toast .v-snack__wrapper {
  background: transparent !important;
  box-shadow: none !important;
  max-width: 460px;
  min-width: 0;
}

.version-toast__surface {
  width: min(460px, calc(100vw - 32px));
  padding: 18px 20px 16px;
  border: 1px solid #c5e7f7;
  border-top: 4px solid #0d9fea;
  border-radius: 12px;
  background: #ffffff;
  color: #193b52;
  box-shadow: 0 16px 38px rgba(28, 66, 82, 0.18);
  text-align: center;
}

.version-toast__eyebrow {
  color: #087fb9;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.version-toast__message {
  margin-top: 5px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.45;
}

.version-toast__actions {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 14px;
}

.version-toast__button {
  min-width: 104px;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.2;
  cursor: pointer;
}

.version-toast__button--later {
  border: 1px solid #c9dce7;
  background: #ffffff;
  color: #52758c;
}

.version-toast__button--reload {
  border: 1px solid #0d9fea;
  background: #0d9fea;
  color: #ffffff;
}

.profile-gravatar {
  width: 48px;
  height: 48px;
}

.profile-container {
  display: flex;
  align-items: center;
  text-align: left;
  padding: 0px;
  margin: 2px;
}

.profile-circle {
  text-align: left;
  background: #39a7eb;
  border: 0.5px solid gray;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: inline-block;
  text-align: left;
}

.profile-text {
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  line-height: 30px;
}

.profile-name {
  display: inline-block;
  align-items: center;
  margin-left: 5px;
}
</style>
